import { AaSigninReq } from 'app/bff/models/aa/aaSignin';

export const MEMBER_REGISTER_NSMODAL__BY_PASS_PHRASE = 'MEMBER_REGISTER_NSMODAL__BY_PASS_PHRASE';

export interface RegisterNSModalByPassPhraseAction {
    type: typeof MEMBER_REGISTER_NSMODAL__BY_PASS_PHRASE;
    payload: {
      authMemberArgs: AaSigninReq;
    };
  }

export type RegisterNSModalActions =
RegisterNSModalByPassPhraseAction
// ::: End
